import { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Input,
  Label,
} from "reactstrap";
import Cropper from "react-easy-crop";
import { ASPECTS } from "../utils/formConfig";

export default function ImageCropModal({ isOpen, cropSrc, onClose, onSave }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [enableCrop, setEnableCrop] = useState(true);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [aspect, setAspect] = useState(ASPECTS.square);

  // Reset state whenever modal opens with a new image
  useEffect(() => {
    if (isOpen && cropSrc) {
      setCrop({ x: 0, y: 0 });
      setZoom(1);
      setEnableCrop(true);
      setAspect(ASPECTS.square);
      setCroppedAreaPixels(null);
    }
  }, [isOpen, cropSrc]);

  return (
    <Modal isOpen={isOpen} centered size="lg">
      <ModalHeader toggle={onClose}>Adjust Image</ModalHeader>

      <ModalBody>
        {/* ENABLE CROP TOGGLE */}
        <FormGroup switch className="mb-3">
          <Input
            type="switch"
            checked={enableCrop}
            onChange={() => setEnableCrop(!enableCrop)}
          />
          <Label check>Enable Crop</Label>
        </FormGroup>

        {/* Aspect ratio buttons */}
        <div className="d-flex gap-2 mb-3">
          <Button
            size="sm"
            outline={aspect !== ASPECTS.square}
            onClick={() => setAspect(ASPECTS.square)}
          >
            1:1
          </Button>

          <Button
            size="sm"
            outline={aspect !== ASPECTS.portrait}
            onClick={() => setAspect(ASPECTS.portrait)}
          >
            3:4
          </Button>

          <Button
            size="sm"
            outline={aspect !== ASPECTS.landscape}
            onClick={() => setAspect(ASPECTS.landscape)}
          >
            16:9
          </Button>

          <Button
            size="sm"
            outline={aspect !== undefined}
            onClick={() => setAspect(undefined)} // free crop
          >
            Free
          </Button>
        </div>

        {/* CROP AREA */}
        <div
          style={{
            position: "relative",
            height: 320,
            background: "#0f172a",
            borderRadius: 12,
            overflow: "hidden",
          }}
        >
          {cropSrc && enableCrop ? (
            <Cropper
              image={cropSrc}
              crop={crop}
              zoom={zoom}
              aspect={aspect}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={(_, croppedPixels) => {
                setCroppedAreaPixels(croppedPixels);
              }}
            />
          ) : cropSrc ? (
            <img
              src={cropSrc}
              alt="Preview"
              style={{
                maxHeight: "100%",
                maxWidth: "100%",
                display: "block",
                margin: "0 auto",
              }}
            />
          ) : (
            <div className="text-center text-muted p-4">
              No image selected
            </div>
          )}
        </div>

        {enableCrop && cropSrc && (
          <FormGroup className="mt-3">
            <Label>Zoom</Label>
            <Input
              type="range"
              min={1}
              max={3}
              step={0.1}
              value={zoom}
              onChange={(e) => setZoom(Number(e.target.value))}
            />
          </FormGroup>
        )}
      </ModalBody>

      <ModalFooter>
        <Button color="light" onClick={onClose}>
          Cancel
        </Button>
        <Button
          color="primary"
          disabled={!cropSrc}
          onClick={() => onSave(croppedAreaPixels, enableCrop)}
        >
          Apply
        </Button>
      </ModalFooter>
    </Modal>
  );
}
